<script lang="ts" setup>
import type { Brand } from '~/types/Brand';

defineProps<{ brand: Brand; showTitle?: boolean }>();
</script>

<template>
  <div class="brand-logo-block">
    <div class="brand-logo-block__image-box">
      <picture
        v-if="brand.logo"
        class="brand-logo-block__image"
      >
        <source
          v-if="brand.logo.conversions_webp?.thumb_80"
          :srcset="`${brand.logo.conversions_webp.thumb_80}, ${brand.logo.conversions_webp.thumb_180} 2x`"
          type="image/webp"
        />

        <source
          v-if="brand.logo.conversions?.thumb_80"
          :srcset="brand.logo.conversions.thumb_80"
          type="image/jpeg"
        />

        <img
          :alt="brand.name"
          :src="brand.logo.url"
          class="brand-logo-block__image"
        />
      </picture>

      <SvgoNoPhotoSmall
        v-else
        :font-controlled="false"
        class="w-10 h-10"
        filled
      />
    </div>

    <div
      v-if="showTitle"
      class="text-2xs text-center"
    >
      {{ brand.name }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.brand-logo-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 60px;

  @include screen-sm {
    width: 80px;
  }

  &__image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    padding: 8px;
    border: 1px solid $hell-black-10;
    border-radius: 12px;
    background-color: $white;
    transition: all 0.2s;
    aspect-ratio: 1/1;

    @apply shadow-lg;

    @include screen-sm {
      width: 80px;
      height: 80px;
    }

    &:hover {
      @apply shadow-md;
      @apply translate-y-0.5;
    }
  }

  &__image {
    width: auto;
  }
}
</style>
